import React from "react";
import { Img, Section } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import ProductPageLabels from "./ProductPageLabels";
import ProductPagePricing from "./ProductPagePricing";
import NoProductImage from "../../assets/Images/NoProductImage.jpeg";

const sectionStyle = css`
  flex-direction: row;
  padding: 10vh 10vw;
  min-height: 70vh;
  gap: 3vh;
`;
const sectionStyleMb = css`
  flex-direction: column;
  align-items: center;
  padding: 5vh 3vw;
`;
const imgSize = css`
  height: 35vh;
  aspect-ratio: 1/1;
  box-shadow: 0 0 2px 1px grey;
`;
const widthSize = css`
  width: 100%;
`;

const ProductPage = ({ product }) => {
  return (
    <Section $baseStyle={sectionStyle} $mStyle={sectionStyleMb}>
      <Img
        $baseStyle={imgSize}
        $mStyle={widthSize}
        alt="product image"
        src={product["imageURL"] || NoProductImage}
      />
      <ProductPageLabels product={product} />
      <ProductPagePricing product={product} />
    </Section>
  );
};

export default ProductPage;
